var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',_vm._b({attrs:{"color":"primary"}},'v-icon',_vm.$attrs,false),[_vm._v(" mdi-filter-variant ")])}
var staticRenderFns = []

export { render, staticRenderFns }